export default __webpack_public_path__ + "static/media/5.94c905f0.jpg";